/* R&R Labor Day rebuild v3: reward-modal polish + verified cart celebration. */
(() => {
  const body = () => document.body;
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const text = el => (el?.textContent || '').replace(/\s+/g,' ').trim();
  const safeSessionGet = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const safeSessionSet = (key,value) => { try { sessionStorage.setItem(key,value); } catch {} };

  function closestUsefulRoot(el) {
    if (!el) return null;
    const dialog = el.closest('[role="dialog"],dialog,[aria-modal="true"]');
    if (dialog) return dialog;
    let node = el;
    for (let i=0; node && i<9; i++, node=node.parentElement) {
      const style = getComputedStyle(node);
      const rect = node.getBoundingClientRect();
      if ((style.position === 'fixed' || style.position === 'sticky') && rect.width > 280 && rect.height > 280) return node;
    }
    return el.closest('[class*="modal" i],[class*="popup" i],[class*="drawer" i]');
  }

  function markGiftCard(button) {
    let node = button.parentElement;
    for (let i=0; node && i<6; i++, node=node.parentElement) {
      const hasImage = Boolean(node.querySelector('img'));
      const rect = node.getBoundingClientRect();
      if (hasImage && rect.height > 70 && rect.height < 340) { node.classList.add('rr-gift-card'); return; }
    }
  }

  function markHelpLauncher(open) {
    document.querySelectorAll('button,a,iframe').forEach(el => {
      const label = [text(el),el.getAttribute?.('aria-label'),el.getAttribute?.('title')].filter(Boolean).join(' ');
      if (/need help|help|support|chat/i.test(label) && (getComputedStyle(el).position === 'fixed' || el.tagName === 'IFRAME')) el.classList.toggle('rr-help-under-gift', open);
    });
  }

  function styleGiftReward() {
    const claim = [...document.querySelectorAll('button,a')].find(el => /claim all to cart|claim.*to cart/i.test(text(el)));
    const eligible = [...document.querySelectorAll('div,p,span,h1,h2,h3')].find(el => /eligible for reward/i.test(text(el)) && text(el).length < 180);
    const anchor = claim || eligible;
    if (!anchor) {
      body()?.classList.remove('rr-gift-open');
      markHelpLauncher(false);
      return;
    }
    const root = closestUsefulRoot(anchor);
    if (!root) return;
    root.classList.add('rr-gift-modal');
    body()?.classList.add('rr-gift-open');
    markHelpLauncher(true);

    const heading = [...root.querySelectorAll('h1,h2,h3,p,div,span')].find(el => /choose\s*1\s*product|eligible for reward/i.test(text(el)) && text(el).length < 120);
    heading?.classList.add('rr-gift-heading');
    root.querySelectorAll('input[type="search"],input[placeholder*="Search" i]').forEach(el => el.classList.add('rr-gift-search'));
    root.querySelectorAll('button,a').forEach(el => {
      if (/^select$/i.test(text(el))) { el.classList.add('rr-gift-select'); markGiftCard(el); }
      if (/claim.*to cart/i.test(text(el))) el.classList.add('rr-gift-action');
    });
    const footerTrigger = [...root.querySelectorAll('label,div,section')].find(el => /do not show this again/i.test(text(el)) && text(el).length < 90);
    if (footerTrigger) {
      let footer = footerTrigger;
      for (let i=0; footer?.parentElement && i<3; i++) {
        if (footer.parentElement.querySelector('.rr-gift-action')) { footer = footer.parentElement; break; }
        footer = footer.parentElement;
      }
      footer?.classList.add('rr-gift-footer');
    }
  }

  let giftQueued = false;
  const giftObserver = new MutationObserver(() => {
    if (giftQueued) return;
    giftQueued = true;
    requestAnimationFrame(() => { giftQueued = false; styleGiftReward(); });
  });

  function burstConfetti() {
    if (reducedMotion()) return;
    const now = Date.now();
    const last = Number(safeSessionGet('rr-confetti-last') || 0);
    if (now - last < 2400) return;
    safeSessionSet('rr-confetti-last', String(now));
    const layer = document.createElement('div');
    layer.className = 'rr-confetti-layer';
    layer.setAttribute('aria-hidden','true');
    const colors = ['#0033cc','#f5c6a6','#ffffff','#d5ddf6','#d2dabd'];
    const originX = innerWidth < 760 ? 50 : 83;
    const originY = innerWidth < 760 ? 19 : 13;
    for (let i=0;i<18;i++) {
      const piece = document.createElement('i');
      piece.className = 'rr-confetti-piece';
      piece.style.setProperty('--x', `${originX + (Math.random()*18-9)}vw`);
      piece.style.setProperty('--y', `${originY + (Math.random()*5-2)}vh`);
      piece.style.setProperty('--dx', `${Math.round(Math.random()*110-55)}px`);
      piece.style.setProperty('--r', `${Math.round(Math.random()*180)}deg`);
      piece.style.setProperty('--c', colors[i % colors.length]);
      piece.style.animationDelay = `${Math.round(Math.random()*110)}ms`;
      layer.append(piece);
    }
    document.body.append(layer);
    setTimeout(() => layer.remove(), 1250);
  }

  function visibleCartCount() {
    const sectionCount = document.querySelector('[data-cart-count]')?.dataset.cartCount;
    if (sectionCount != null && /^\d+$/.test(String(sectionCount).trim())) return Number(sectionCount);
    const rrBag = document.querySelector('[data-rr-bag-count]')?.textContent?.trim();
    if (rrBag && /^\d+$/.test(rrBag)) return Number(rrBag);
    const nativeBag = document.querySelector('#cart-icon-bubble')?.textContent?.match(/\d+/)?.[0];
    return nativeBag ? Number(nativeBag) : null;
  }

  async function fetchCartCount() {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) return null;
      const cart = await response.json();
      return Number.isFinite(Number(cart.item_count)) ? Number(cart.item_count) : null;
    } catch { return null; }
  }

  async function currentCartCount() {
    const visible = visibleCartCount();
    return visible == null ? await fetchCartCount() : visible;
  }

  let lastCartCount = null;
  let cartCheckSequence = 0;

  async function syncCartBaseline() {
    const count = await currentCartCount();
    if (count != null) lastCartCount = count;
    return count;
  }

  async function celebrateVerifiedIncrease() {
    const sequence = ++cartCheckSequence;
    await new Promise(resolve => setTimeout(resolve, 190));
    const count = await currentCartCount();
    if (sequence !== cartCheckSequence || count == null) return;
    const previous = lastCartCount;
    lastCartCount = count;
    if (previous != null && count > previous) burstConfetti();
  }

  async function celebrateCartArrivalOnce() {
    if (safeSessionGet('rr-cart-arrival-celebrated') === '1') return;
    const count = await syncCartBaseline();
    if (count > 0) {
      safeSessionSet('rr-cart-arrival-celebrated','1');
      burstConfetti();
    }
  }

  async function init() {
    document.body?.classList.add('rr-rebuild-v3');
    styleGiftReward();
    giftObserver.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','open','aria-hidden']});
    await syncCartBaseline();
    if (document.querySelector('.rr-cart-section')) setTimeout(celebrateCartArrivalOnce, 320);
  }

  document.addEventListener('eurus:cart:items-changed', celebrateVerifiedIncrease);
  document.addEventListener('rr:cart-updated', () => { styleGiftReward(); syncCartBaseline(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();

/* R&R launch guard v1: the old Eurus free-shipping threshold must never surface. */
(() => {
  const freeShippingCopy = /\bfree\s+(?:standard\s+)?shipping\b|away\s+from\s+free\s+shipping/i;
  let queued = false;

  function removeLegacyFreeShipping() {
    document.querySelectorAll('p,span,small,strong,div').forEach(el => {
      if (el.closest('[data-rr-allow-free-shipping]')) return;
      const copy = (el.textContent || '').replace(/\s+/g,' ').trim();
      if (!copy || copy.length > 180 || !freeShippingCopy.test(copy)) return;
      const component = el.closest('[class*="free-shipping" i],[class*="freeshipping" i],[data-free-shipping]');
      const target = component || el;
      target.setAttribute('hidden','');
      target.setAttribute('aria-hidden','true');
      target.style.setProperty('display','none','important');
    });
  }

  function scheduleCleanup() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      removeLegacyFreeShipping();
    });
  }

  function initLaunchGuard() {
    removeLegacyFreeShipping();
    new MutationObserver(scheduleCleanup).observe(document.body,{subtree:true,childList:true,characterData:true});
    document.addEventListener('eurus:cart:items-changed', scheduleCleanup);
    document.addEventListener('rr:cart-updated', scheduleCleanup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLaunchGuard, {once:true});
  else initLaunchGuard();
})();
